<template>
  <article class="grid has-4-columns gap-2">
    <div class="email-logo-preview">
      <img v-if="previewVisible" :src="staged || branding.email_logo_url">
    </div>
    <div class="is-3-columns">
      <p class="mb-1">To set a custom email logo (used in email headers), upload an image below. The image you choose must be a transparent <abbr title="Portable Network Graphics File (.png)">PNG</abbr> with a maximum size of <span class="has-text-weight-bold">300px × 82px</span>. Please ensure the image is not white, as it will be displayed on a white background.</p>
      <div class="is-flex align-end">
        <file-input
          ref="input"
          class="flex-grow is-marginless"
          @select="brandingEmailLogo">
          New Email Logo
        </file-input>
        <action-button
          v-if="branding.email_logo && !staged"
          v-bind="{ working }"
          @click="reset"
          class="is-danger is-outlined ml-1">
          Reset
        </action-button>
        <action-button
          v-if="staged"
          v-bind="{ working }"
          @click="upload"
          class="is-primary ml-1"
          left-icon="cloud-upload-alt">
          Upload &amp; Set
        </action-button>
      </div>
    </div>
  </article>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { readFile } from '@/utils/file-reader'

export default {

  data: () => ({
    staged: null,
    working: false,
    previewVisible: true,
  }),

  computed: {
    ...mapState('company', ['branding']),
  },

  methods: {
    ...mapMutations('company', [
      'setBrandingEmailLogo',
    ]),

    reloadPreview() {
      // This is due to a bug that stretches the image
      // after its src has been replaced.
      // @todo revisit
      this.previewVisible = false
      setTimeout(() => this.previewVisible = true, 50)
    },

    brandingEmailLogo(file) {
      if (file.type === 'image/png') {
        this.setBrandingEmailLogo(file)
        readFile(file).then(url => {
          let image = new Image()
          let vm = this
          image.onload = function () {
            if (this.height === 82 && this.width === 300) {
              vm.staged = url
              vm.reloadPreview()
            } else {
              vm.$refs.input.files = FileList
              vm.$toast.error('Incorrect Size', 'The size of your logo must be 300px × 82px.')
            }
          }
          image.src = url
        })
      } else {
        this.$refs.input.files = FileList
        this.$toast.error('Incorrect Type', 'Please select a PNG image.')
      }
    },

    upload() {
      this.working = true
      this.$store.dispatch('company/uploadBrandingEmailLogo')
        .then(() => {
          this.staged = null
          this.$refs.input.files = FileList
          this.$toast.success('Success', 'Email logo for your company has been set.')
        })
        .finally(() => this.working = false)
    },

    reset() {
      this.working = true
      this.$store.dispatch('company/resetBrandingEmailLogo')
        .then(() => {
          this.staged = null
          this.$refs.input.files = FileList
          this.reloadPreview()
          this.$toast.success(this.Convert('Success', 'Email logo for your company has been reset.'))
        })
        .finally(() => this.working = false)
    }
  },

}
</script>
